module.exports = __webpack_public_path__ + "static/media/cross-icon.f7dfc275.svg";